import * as React from 'react';

export interface IDownloadsTabProps {
    school: any // Marking this as any because the api response is huge and prone to changing
}


function DownloadsTab({ school }: IDownloadsTabProps) {

    let categories = school.profileDocuments.map(doc => doc.tabDescription);
    categories = categories.filter((n, i) => categories.indexOf(n) === i)

    const blocks = categories.map(category => <div key={category}>
        <h3>{category}</h3>
        <div className="table-scrolling-wrapper">
            <table className="document-list">
                <thead>
                    <tr><th>Report</th><th>Date</th><th>Download</th></tr>
                </thead>
                <tbody>
                    {school.profileDocuments.filter(doc => doc.tabDescription == category).map(doc => <tr key={`${doc.documentTitle}${doc.documentPeriod}`}>
                        <td>{doc.documentTitle}</td>
                        <td>{doc.documentPeriod}</td>
                        <td><a href={doc.downloadURL} target="_blank" className="fa fa-external-link"></a></td>
                    </tr>)}
                </tbody>
            </table>
        </div>
    </div>)

    return <div className="profile-section downloads-tab">
        {blocks}
    </div>
}

export default DownloadsTab;